<span
  (mouseenter)="onShowTooltip($event)"
  (mouseleave)="onHideTooltip()"
  (click)="onHideTooltip()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <ng-content></ng-content>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetX]="offsetX"
  [cdkConnectedOverlayOffsetY]="offsetY"
>
  @if (!order) {
  <div
    class="job-detail-progressbar-container"
    [style.top]="loadingPos.top"
    [style.left]="loadingPos.left"
  >
    <mat-spinner
      class="job-detail-progressbar"
      diameter="40"
    ></mat-spinner>
  </div>
  } @else {
  <div
    class="jobDetailTooltip tooltip-show"
    (mouseenter)="onShowTooltip1()"
    (mouseleave)="onHideTooltip1()"
  >
    <div class="main-container">
      <div class="job-detail-tooltip-header">
        <div class="job-detail-tooltip-title">
          Order:
          <a
            class="td-link ml-5"
            [routerLink]="['/orders', order.job.ordId]"
            >{{ order.job.orderCode }}</a
          >
        </div>
        <div class="progress-container">
          <mat-progress-bar
            class="job-detail-progressbar"
            mode="determinate"
            [value]="order.completePerc"
          ></mat-progress-bar>
          <p>{{ order.completePerc | number : '1.0-0' }}% complete</p>
        </div>
        <p class="machine-title">{{ order.job.status | orderStatus }}</p>
      </div>
      <mat-tab-group
        class="main-color-tab"
        [dynamicHeight]="true"
        [selectedIndex]="1"
        [stretchTabs]="true"
      >
        <mat-tab label="Order">
          <div
            class="p-16 flex-container right-padding-0"
            [style.height]="tableHeight + 'px'"
          >
            <div class="left-container">
              <div class="multi-item-container">
                <div class="item-container">
                  <div class="item-title">Material:</div>
                  <div class="item-content">{{ order.job.materialCode }}</div>
                </div>
                <div class="item-des">{{ order.job.materialDescription }}</div>
              </div>
              <div class="multi-item-container">
                <div class="item-container">
                  <div class="item-title">Tooling:</div>
                  <div class="item-content">
                    @if (order.job.toolingCode) {
                    <app-tooling-preview [toolingCode]="order.job.toolingCode">
                      <a
                        class="td-link"
                        [routerLink]="['/tooling', order.job.toolingCode]"
                        >{{ order.job.toolingCode }}</a
                      >
                    </app-tooling-preview>
                    }
                  </div>
                </div>
                <div class="item-des">{{ order.job.toolingDescription }}</div>
              </div>
              <div class="item-container">
                <div class="item-title">Machine:</div>
                <div class="item-content">{{ order.job.scheduleState?.machine?.description }}</div>
              </div>
              <div class="item-container">
                <div class="item-title">Sequence:</div>
                <div class="item-content">{{ order.job.scheduleState.sequence }}</div>
              </div>
              <div class="item-container">
                <div class="item-title">Customer Name:</div>
                <div class="item-content">{{ order.job.customerName }}</div>
              </div>
              <div class="item-container">
                <div class="item-title"></div>
                <div class="item-content hold-state">
                  @if (!order.job.hold) {
                  <i class="mdi mdi-pause-circle"></i>
                  } @if (order.job.hold) {
                  <i class="mdi mdi-pause-circle-outline"></i>
                  }
                  {{ order.job.hold ? 'Remove hold' : 'Hold' }}
                </div>
              </div>
              <div class="item-container">
                <div class="item-title">Required:</div>
                <div class="item-content">{{ order.job.requiredDate | amsDate }}</div>
              </div>
              <div class="item-container">
                <div class="item-title">
                  @if (order.job.scheduleState.state === 'Scheduled') {
                  <span>Estimated:</span>
                  } @if (order.job.scheduleState.state === 'Done') {
                  <span>Completed:</span>
                  }
                </div>
                <div class="item-content">{{ order.job.completionDate | amsDateTime }}</div>
              </div>
            </div>
            <div class="right-container">
              <div class="item-container">
                <div class="item-title">Total:</div>
                <div class="item-content">
                  {{ order.job.totalFt | unitsFormat : 'ft' : 2 : true
                  }}<span class="sign">{{ 'ft' | userDisplayUnits }}</span>
                </div>
              </div>
              <div class="item-container remaining-item">
                <div class="item-title">Remaining:</div>
                <div class="item-content">
                  {{ order.job.remainingFt | unitsFormat : 'ft' : 2 : true
                  }}<span class="sign">{{ 'ft' | userDisplayUnits }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Items">
          <div
            class="p-16 bp-0 job-detail-scroll-container"
            [style.height]="tableHeight + 'px'"
          >
            <table class="table-container">
              <tr>
                @for (col of itemHeaders | filterByKey : 'isVisible' : true; track $index) {
                <th class="job-detail-col-item job-detail-col-item-header">
                  <span>{{ col.title }}</span>
                </th>
                }
              </tr>
              @for (item of order.items; track trackByKey($index, item)) {
              <tr class="hover order-detail-item">
                @for (col of itemHeaders | filterByKey : 'isVisible' : true; track $index) {
                <td class="job-detail-col-item">
                  @if (col.field !== 'bundle' && col.field !== 'patternName') {
                  <span>{{ item[col.field] | unitsFormat : col.units : col.unitDecimals }}</span>
                  } @if (col.field === 'bundle') {
                  <span>{{ item[col.field] }}</span>
                  } @if (col.field === 'patternName') {
                  <span>
                    <app-punch-pattern-preview [patternId]="item.patternId">
                      <a
                        class="td-link ml-5"
                        [routerLink]="['/punching/patterns', item.patternId]"
                      >
                        {{ item.patternName || item.patternId }}
                      </a>
                    </app-punch-pattern-preview>
                  </span>
                  }
                </td>
                }
              </tr>
              }
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Bundles">
          <div
            class="p-16 bp-0 job-detail-scroll-container"
            [style.height]="tableHeight + 'px'"
          >
            <table class="table-container">
              <tr>
                @for (col of bundleItemHeaders; track $index) {
                <th class="job-detail-col-item job-detail-col-item-header">
                  <span>{{ col.title }}</span>
                </th>
                }
              </tr>
              @for (item of order.bundles; track trackByKey($index, item)) {
              <tr class="hover order-detail-item">
                @for (col of bundleItemHeaders; track $index) {
                <td class="job-detail-col-item">
                  {{ item[col.field] }}
                </td>
                }
              </tr>
              }
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  }
</ng-template>
